import axios, { AxiosError } from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiURI, setAuthToken } from "../common";
import { SSOLoginForm } from ".";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { loginRequest } from "../common/functions/authConfig";
import { callMsGraph } from "../graph";
import { InteractionRequiredAuthError } from "@azure/msal-browser";

export function LoginPage() {
  // Use navigate hook for navigation
  const history = useNavigate();
  // State to hold error messages
  const [errors, setErrors] = useState({});
  // Access MSAL instance and accounts
  const { instance, accounts } = useMsal();
  // Check if the user is authenticated
  const isAuthenticated = useIsAuthenticated();

  // Function to handle login button
  const handleLoginButton = () => {
    if (isAuthenticated) {
      // Clear local storage and reload page on successful login
      localStorage.clear();
      window.location.reload();
    }

    // Attempt login if not authenticated
    !isAuthenticated &&
      instance.loginRedirect(loginRequest).catch((e) => {
        console.error(e);
      });
  };

  // Effect to handle login submission
  useEffect(() => {
    isAuthenticated && handleSubmit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  // Function to handle login submission
  const handleSubmit = async () => {
    try {
      // Attempt to acquire token silently
      const msalResponse = await instance.acquireTokenSilent({
        ...loginRequest,
        account: accounts[0],
      });

      // Call Microsoft Graph API
      const graphResponse = await callMsGraph(msalResponse.accessToken);

      // Extract userPrincipalName from graph response
      const { userPrincipalName } = graphResponse;
      if (!userPrincipalName) throw new Error("error in graph response");

      // Prepare login user object
      const loginUser = {
        email: userPrincipalName,
        msToken: msalResponse.idToken,
      };

      // Make a POST request to login endpoint
      const response = await axios.post(`${apiURI}/auth/login`, loginUser);
      const { token } = response.data;

      // Store JWT token in local storage
      //// ls only stores strings. u can convert json to string -> parse it back
      localStorage.setItem("jwtToken", token);
      dispatchEvent(new Event("storage"));
      // Set token to Auth header
      setAuthToken(token);
      // Redirect to home page
      history("/");
    } catch (error) {
      if (error instanceof InteractionRequiredAuthError) {
        await instance.acquireTokenRedirect(loginRequest);
      }

      //  coming from const response = await axios.post(`${apiURI}/auth/login`, loginUser)
      if (error instanceof AxiosError) {
        console.log("error in axios login call react", error.response?.data);
        setErrors({});
        setErrors(error.response?.data ?? { message: "Network error: API unreachable" });
      }
    }
    // eslint-disable-next-line no-console
  };

  return (
    <SSOLoginForm
      errors={errors}
      handleSubmit={handleLoginButton}
    ></SSOLoginForm>
  );
}
